export const eventManagerTypes = {
    GET_EVENTS_REQUEST: "GET_EVENTS_REQUEST",
    GET_EVENTS_SUCCESS: "GET_EVENTS_SUCCESS",
    GET_EVENTS_FAILURE: "GET_EVENTS_FAILURE",
    GET_ORGANIZERS_REQUEST: "GET_ORGANIZERS_REQUEST",
    GET_ORGANIZERS_SUCCESS: "GET_ORGANIZERS_SUCCESS",
    GET_ORGANIZERS_FAILURE: "GET_ORGANIZERS_FAILURE",
    GET_SINGLE_EVENT_REQUEST: "GET_SINGLE_EVENT_REQUEST",
    GET_SINGLE_EVENT_SUCCESS: "GET_SINGLE_EVENT_SUCCESS",
    GET_SINGLE_EVENT_FAILURE: "GET_SINGLE_EVENT_FAILURE",
    GET_EVENT_VENDORS_REQUEST: "GET_EVENT_VENDORS_REQUEST",
    GET_EVENT_VENDORS_SUCCESS: "GET_EVENT_VENDORS_SUCCESS",
    GET_EVENT_VENDORS_FAILURE: "GET_EVENT_VENDORS_FAILURE",
    CREATE_EVENT_REQUEST: "CREATE_EVENT_REQUEST",
    CREATE_EVENT_SUCCESS: "CREATE_EVENT_SUCCESS",
    CREATE_EVENT_FAILURE: "CREATE_EVENT_FAILURE",
    UPDATE_EVENT_REQUEST: "UPDATE_EVENT_REQUEST",
    UPDATE_EVENT_SUCCESS: "UPDATE_EVENT_SUCCESS",
    UPDATE_EVENT_FAILURE: "UPDATE_EVENT_FAILURE",
    PUBLISH_EVENT_REQUEST: "PUBLISH_EVENT_REQUEST",
    PUBLISH_EVENT_SUCCESS: "PUBLISH_EVENT_SUCCESS",
    PUBLISH_EVENT_FAILURE: "PUBLISH_EVENT_FAILURE",
    UNPUBLISH_EVENT_REQUEST: "UNPUBLISH_EVENT_REQUEST",
    UNPUBLISH_EVENT_SUCCESS: "UNPUBLISH_EVENT_SUCCESS",
    UNPUBLISH_EVENT_FAILURE: "UNPUBLISH_EVENT_FAILURE",
};
